module.exports = __webpack_public_path__ + "fonts/icons.0d3693c.eot";